import { render, staticRenderFns } from "./deductionsUnderCdeu.vue?vue&type=template&id=53706662&scoped=true"
import script from "./deductionsUnderCdeu.vue?vue&type=script&lang=js"
export * from "./deductionsUnderCdeu.vue?vue&type=script&lang=js"
import style0 from "./deductionsUnderCdeu.vue?vue&type=style&index=0&id=53706662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53706662",
  null
  
)

export default component.exports